<template>
	<section class="page page-extras-rulebook">
		<!-- Do nothing -->
	</section>
</template>

<script lang="ts">
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageExtrasRulebook extends PageBase {}
</script>

<style lang="scss">
	.page-extras-rulebook {
		// Not implemented
	}
</style>
